"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MenuButton extends HTMLButtonElement {
    constructor() {
        super();
        this.menu = null;
        this.toggle = this.toggle.bind(this);
    }
    connectedCallback() {
        this.menu = this.findMenu();
        this.setAttribute('aria-controls', this.menu.id);
        this.setAttribute('aria-expanded', 'false');
        this.addEventListener('click', this.toggle);
    }
    toggle() {
        const menu = this.menu;
        if (menu.hidden) {
            menu.hidden = false;
            this.setAttribute('aria-expanded', 'true');
        }
        else {
            menu.hidden = true;
            this.setAttribute('aria-expanded', 'false');
        }
    }
    findMenu() {
        const id = this.dataset.target;
        if (!id) {
            throw new Error('Menu id not specified');
        }
        const menu = document.getElementById(id);
        if (!menu) {
            throw new Error(`Invalid menu element "${id}"`);
        }
        return menu;
    }
}
exports.default = MenuButton;
customElements.define('sarsons-menu-button', MenuButton, {
    extends: 'button',
});
